import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Home, User, Gift, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useKeyboardOpen } from '@/hooks/use-keyboard-open'

const navItems = [
  { path: '/', icon: Home, label: 'Каталог' },
  { path: '/my-giveaways', icon: Gift, label: 'Мои' },
  { path: '/create', icon: Plus, label: 'Создать' },
  { path: '/profile', icon: User, label: 'Профиль' },
]

export function Layout() {
  const location = useLocation()
  const navigate = useNavigate()
  const keyboardOpen = useKeyboardOpen()

  return (
    <div className="flex flex-col min-h-screen">
      <main className={cn('flex-1', keyboardOpen ? 'pb-0' : 'pb-20')}>
        <Outlet />
      </main>

      <nav
        className={cn(
          'fixed bottom-0 left-0 right-0 bg-black dark:bg-secondary border-t border-border safe-area-bottom z-50',
          keyboardOpen && 'hidden'
        )}
      >
        <div className="flex items-center justify-around h-16">
          {navItems.map(({ path, icon: Icon, label }) => {
            const isActive = location.pathname === path
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={cn(
                  'flex flex-col items-center justify-center w-full h-full gap-1 transition-colors',
                  isActive ? 'text-white dark:text-foreground' : 'text-white/70 dark:text-muted-foreground'
                )}
              >
                <Icon className="h-5 w-5" />
                <span className="text-xs">{label}</span>
              </button>
            )
          })}
        </div>
      </nav>
    </div>
  )
}
